//페이지 별 url 및 파일 경로 지정
export const pageRouting = [];
//서브 페이지 별 추가 js,css 호출 url 조합
export const dataUrlArray = [];
function pagePushFunc() {
	var titleArray = [
		'오토입찰솔루션 - 로그인',
		'오토입찰솔루션 - 조회/입찰',
		'오토입찰솔루션 - 데이터 생성',
		'오토입찰솔루션 - 즐겨찾기',
		'오토입찰솔루션 - 환경설정'
	];
	var urlArray = [
		'/member/login',
		'/sub/bidding',
		'/sub/create',
		'/sub/favorite',
		'/sub/setting'
	];
	var pageUrl = [
		'/member/login/login.html',
		'/sub/bidding.html',
		'/sub/dataCreate.html',
		'/sub/favorite.html',
		'/sub/setting.html'
	];
	var callUrl = [
		'member/login.min',
		'sub/bidding.min',
		'sub/create.min',
		'sub/favorite.min',
		'sub/setting.min'
	];
	for (var i =0; i <= titleArray.length; i++ ) {
		var routeUrl = {
			'title':titleArray[i],
			'url':urlArray[i],
			'callurl':pageUrl[i]
		};
		var dataUrl = {
			'url':urlArray[i],
			'callurl':callUrl[i]
		};
		pageRouting.push(routeUrl);
		dataUrlArray.push(dataUrl);
	}
}
pagePushFunc();



// WEBPACK FOOTER //
// ./js/controller/route/pageUrl.js